(function () {
  function initBookstoreSlider(row) {
    var viewport = row.querySelector('.bookstore-home__slider-viewport');
    var track = row.querySelector('.bookstore-home__products');
    var prevButton = row.querySelector('.bookstore-home__slider-btn--prev');
    var nextButton = row.querySelector('.bookstore-home__slider-btn--next');

    if (!viewport || !track || !prevButton || !nextButton) {
      return;
    }

    function getSlideWidth() {
      var card = track.querySelector('.bookstore-card');
      if (!card) {
        return viewport.clientWidth;
      }
      var style = window.getComputedStyle(card);
      var width = card.getBoundingClientRect().width;
      var gap = parseFloat(style.marginRight || 0);
      return width + gap;
    }

    function updateButtons() {
      var scrollLeft = Math.round(track.scrollLeft);
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevButton.disabled = scrollLeft <= 0;
      nextButton.disabled = scrollLeft >= maxScroll - 1;
    }

    function scrollByStep(direction) {
      var step = getSlideWidth();
      track.scrollBy({
        left: direction * step,
        behavior: 'smooth'
      });
    }

    prevButton.addEventListener('click', function () {
      scrollByStep(-1);
    });

    nextButton.addEventListener('click', function () {
      scrollByStep(1);
    });

    track.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', updateButtons);

    updateButtons();
  }

  function initBookstoreSidebar(section) {
    var sidebar = section.querySelector('.bookstore-sidebar');
    var button = section.querySelector('.bookstore-sidebar__heading-button');
    var menu = section.querySelector('.bookstore-sidebar__menu');

    if (!sidebar || !button || !menu) {
      return;
    }

    button.addEventListener('click', function () {
      var isOpen = sidebar.classList.toggle('is-open');
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function initBookstoreSidebarFlyouts(section) {
    section.querySelectorAll('.bookstore-sidebar__toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        var item = toggle.closest('.bookstore-sidebar__item');
        if (!item) {
          return;
        }
        var isOpen = item.classList.toggle('is-flyout-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  var WISHLIST_STORAGE_KEY = 'bookstoreWishlist';

  function getWishlist() {
    try {
      return JSON.parse(window.localStorage.getItem(WISHLIST_STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(ids) {
    window.localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(ids));
  }

  function initBookstoreWishlist(section) {
    var saved = getWishlist();

    section.querySelectorAll('.bookstore-card__wishlist').forEach(function (button) {
      var id = button.getAttribute('data-product-id');
      var icon = button.querySelector('i');

      function paint(isActive) {
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (icon) {
          icon.className = isActive ? 'icon-heart' : 'icon-heart-outline';
        }
      }

      paint(saved.indexOf(id) !== -1);

      button.addEventListener('click', function () {
        var current = getWishlist();
        var index = current.indexOf(id);
        var isActive;
        if (index === -1) {
          current.push(id);
          isActive = true;
        } else {
          current.splice(index, 1);
          isActive = false;
        }
        setWishlist(current);
        paint(isActive);
      });
    });
  }

  function initAllBookstoreSliders() {
    document.querySelectorAll('.bookstore-home').forEach(function (section) {
      section.querySelectorAll('.bookstore-home__row').forEach(initBookstoreSlider);
      initBookstoreSidebar(section);
      initBookstoreSidebarFlyouts(section);
      initBookstoreWishlist(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBookstoreSliders);
  } else {
    initAllBookstoreSliders();
  }
})();
